import { createFileRoute } from '@tanstack/react-router';

import { requireActiveOrganisation, requireTwoFactorEnrolment } from '@/app/guards';
import { AdminShell } from '@/app/shell';

/** Active organisations only, and staff the two-factor rule lets in; renders the frame. */
export const Route = createFileRoute('/_authed/_active')({
  beforeLoad: ({ context, location }) => {
    requireActiveOrganisation(context.me);
    requireTwoFactorEnrolment(context.me, location);
  },
  component: AdminShell,
});
